/**
 * @classdesc 字典数据
 * @property {String} label 标签
 * @property {*} value 标签
 * @property {Object} raw 原始数据
 */
import { translateUi } from '../../i18n'

export default class DictData {
  constructor (label, value, raw) {
    Object.defineProperty(this, 'label', {
      enumerable: true,
      configurable: true,
      get: () => translateUi(label)
    })
    this.value = value
    this.raw = raw
  }
}
